module.exports = __webpack_public_path__ + "img/icon-star-filled-yellow.479ebc6c441e50a23b5afddcfba98605.svg";